import { convertPersianToEnglish } from '@insta-club/utilities';
import { TextareaType } from './types';

export const validateTextarea = (value: string, type: TextareaType): string => {
    switch (type) {
        case 'number': {
            const converted = convertPersianToEnglish(value);
            return converted.replace(/[^\d]/g, '');
        }
        case 'persian':
            return value.replace(/[^\u0600-\u06FF\u200C\u200D\s۰-۹ ]/g, '');
        case 'english':
            return value.replace(/[^\u0000-\u007F]/g, '');
        default:
            return value;
    }
};
